import { useUpdateCompanySite } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.UPDATE_COMPANY_SITE';

type UseSetCompanySiteAsHeadquarterReturnType = {
  setSiteAsHeadquarter: (siteId: string) => void;
};

export const useSetCompanySiteAsHeadquarter = (
  companyId: string
): UseSetCompanySiteAsHeadquarterReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutate: mutateUpdate } = useUpdateCompanySite();

  const onSuccess = async (): Promise<void> => {
    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
      error,
    });
  };

  const setSiteAsHeadquarter = (siteId: string): void => {
    mutateUpdate(
      { companyId, siteId, data: { isHeadquarter: true } },
      { onSuccess, onError }
    );
  };

  return { setSiteAsHeadquarter };
};
